/* Diabec consent-gated marketing pixel loader (Meta + TikTok).
   Replaces the inline pixel scripts that previously fired in <head> before consent.
   Load with: <script src="diabec-pixels.js" defer></script>
              <script src="../diabec-pixels.js" defer></script>   (from /blog/)

   Behaviour:
     - On load, defines fbq/ttq stubs so downstream code can call them safely.
     - Listens for the 'diabec:consent' event dispatched by diabec-cookie-banner.js.
     - When marketing consent is granted, dynamically injects the real Meta + TikTok
       loaders and fires a PageView for each.
     - Reads existing consent from localStorage on load and grants immediately if
       the user has already opted in (so the pixels work on return visits).

   Configure pixel IDs once below. Placeholder = pixel stays inert.
*/
(function () {
    'use strict';

    var META_PIXEL_ID   = 'META_PIXEL_PLACEHOLDER';
    var TIKTOK_PIXEL_ID = 'TIKTOK_PIXEL_PLACEHOLDER';

    var loaded = { meta: false, tiktok: false };

    // ── fbq stub: queues calls until the real loader arrives ──────────────────
    if (!window.fbq) {
        var n = window.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!window._fbq) window._fbq = n;
        n.push = n; n.loaded = false; n.version = '2.0'; n.queue = [];
    }

    // ── ttq stub: queues calls until the real loader arrives ──────────────────
    if (!window.ttq) {
        var ttq = window.ttq = [];
        ttq.methods = ['page','track','identify','instances','debug','on','off','once',
                       'ready','alias','group','enableCookie','disableCookie',
                       'holdConsent','revokeConsent','grantConsent'];
        ttq.setAndDefer = function (target, method) {
            target[method] = function () {
                target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
            };
        };
        for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
    }

    function loadMetaPixel() {
        if (loaded.meta) return;
        if (META_PIXEL_ID === 'META_PIXEL_PLACEHOLDER') return; // not configured
        loaded.meta = true;
        var s = document.createElement('script');
        s.async = true;
        s.src = 'https://connect.facebook.net/en_US/fbevents.js';
        var first = document.getElementsByTagName('script')[0];
        first.parentNode.insertBefore(s, first);
        window.fbq('init', META_PIXEL_ID);
        window.fbq('track', 'PageView');
    }

    function loadTikTokPixel() {
        if (loaded.tiktok) return;
        if (TIKTOK_PIXEL_ID === 'TIKTOK_PIXEL_PLACEHOLDER') return; // not configured
        loaded.tiktok = true;
        // Re-build ttq with full loader (matches official TikTok snippet)
        var t = 'ttq';
        var w = window, d = document;
        w.TiktokAnalyticsObject = t;
        var ttq = w[t];
        ttq.instance = function (e) {
            for (var n = ttq._i[e] || [], r = 0; r < ttq.methods.length; r++) ttq.setAndDefer(n, ttq.methods[r]);
            return n;
        };
        ttq.load = function (e, n) {
            var r = 'https://analytics.tiktok.com/i18n/pixel/events.js';
            ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r;
            ttq._t = ttq._t || {}; ttq._t[e] = +new Date();
            ttq._o = ttq._o || {}; ttq._o[e] = n || {};
            var s = d.createElement('script');
            s.type = 'text/javascript'; s.async = true;
            s.src = r + '?sdkid=' + e + '&lib=' + t;
            var f = d.getElementsByTagName('script')[0];
            f.parentNode.insertBefore(s, f);
        };
        ttq.load(TIKTOK_PIXEL_ID);
        ttq.page();
    }

    function grantMarketingConsent() {
        loadMetaPixel();
        loadTikTokPixel();
    }

    // ── React to consent decisions ────────────────────────────────────────────
    window.addEventListener('diabec:consent', function (e) {
        if (e && e.detail && e.detail.marketing) grantMarketingConsent();
    });

    // ── Honour existing consent on page load (returning visitors) ─────────────
    try {
        if (localStorage.getItem('diabec_consent_marketing') === 'true' ||
            localStorage.getItem('diabec_cookie_consent') === 'all') {
            grantMarketingConsent();
        }
    } catch (err) { /* localStorage unavailable — stay inert */ }
})();
